import { useSelector } from "react-redux";
import {
  selectBreakdownItems,
  selectMerchantFee,
  selectProcessingFees,
  selectScenario,
  selectSelectedMonthEntry,
} from "../../pricingToolSlice";
import { eur, monthLong } from "../shared/formatters";
import BucketTooltip from "../shared/BucketTooltip";
import styles from "../../PricingTool.module.css";

export default function NetTakeBreakdown() {
  const items = useSelector(selectBreakdownItems);
  const selectedMonth = useSelector(selectSelectedMonthEntry);
  const gross = useSelector(selectMerchantFee);
  const fees = useSelector(selectProcessingFees);
  const { totalNet } = useSelector(selectScenario);
  // What the partners take sits in the net take once that basis is on, so it
  // has to be named for the three lines to add back to what the merchant pays.
  const partner = gross - totalNet - fees;
  const showPartner = Math.abs(partner) > 0.005;

  const billRow = (label: string, amount: number) => (
    <div className={styles.merchant_bill_row}>
      <span>{label}</span>
      <span>{eur(amount, 2)}</span>
    </div>
  );

  return (
    <div className={styles.breakdown_card}>
      <div className={styles.merchant_bill}>
        <div className={styles.merchant_bill_total}>
          <span className={styles.merchant_bill_label}>Merchant pays</span>
          <span className={styles.merchant_bill_amount}>{eur(gross, 2)}</span>
        </div>
        <div className={styles.merchant_bill_sub}>
          {showPartner
            ? "Net take, partner markup, and scheme and other fees"
            : "Net take plus scheme and other fees"}
        </div>
        {billRow("Net take", totalNet)}
        {showPartner && billRow("Partner markup", partner)}
        {billRow("Scheme and other fees", fees)}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <span
          style={{ fontSize: 14, fontWeight: 600, color: "rgba(0,0,0,0.88)" }}
        >
          Net take breakdown
        </span>
        <span style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>
          {selectedMonth ? monthLong(selectedMonth.month) : "Whole period"}
        </span>
      </div>
      {items.map((b, i) => (
        <div key={i} className={styles.breakdown_row}>
          <div className={styles.breakdown_row_header}>
            <BucketTooltip buckets={b.buckets} color={b.color}>
              <span
                className={styles.breakdown_row_label}
                style={{ cursor: "default" }}
              >
                <span
                  className={styles.breakdown_dot}
                  style={{ background: b.color }}
                />
                {b.label}
              </span>
            </BucketTooltip>
            <span className={styles.breakdown_amount}>
              {eur(b.net)} · {Math.round(b.pct)}%
            </span>
          </div>
          <div className={styles.breakdown_bar_track}>
            <div
              className={styles.breakdown_bar_fill}
              style={{ width: b.pct + "%", background: b.color }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
